import React, { useState } from 'react';

import i18n from '@/settings/i18n';
import * as styles from './LanguageSwitcher.module.scss';

import { Dropdown } from '@/components/shared/Dropdown';

type LanguageOptions = {
  [key: string]: string;
};

const languageOptions: LanguageOptions = {
  ja: '日本語 (Japanese)',
  en: 'English',
};

export const LanguageSwitcher: React.FC = () => {
  const [currentLanguage, setCurrentLanguage] = useState(i18n.languages[0]);

  const handleChangeLanguage = (language: string) => {
    i18n.changeLanguage(language);
    setCurrentLanguage(language);
    window.location.reload();
  };

  return (
    <Dropdown
      dataTest="language-switcher"
      buttonClassNames={styles.pannel}
      text={languageOptions[currentLanguage]}
      menuWrapperClassNames={styles.options}
      menuNode={
        <>
          {Object.keys(languageOptions).map((language, index) => (
            <div
              data-test={`language-switcher-${language}`}
              className={styles.pannel}
              key={index}
              onClick={() => {
                handleChangeLanguage(language);
              }}
            >
              {languageOptions[language]}
            </div>
          ))}
        </>
      }
    />
  );
};
